var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-box p-5" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-box__content" },
        [
          _vm.has_error
            ? [_vm._v("\n            Error loading 2FA data\n        ")]
            : _vm.has_data === false
            ? [_vm._v("\n            Loading data ...\n        ")]
            : [
                _vm.twofa_activated === false
                  ? [
                      _c("div", { staticClass: "alert alert-info" }, [
                        _vm._v(
                          "\n                    Your account administrator has requested that two factor authentication should be enabled on\n                    your account\n                "
                        )
                      ]),
                      _vm._v(
                        "\n                2FA Authenticator Code :\n                "
                      ),
                      _c("pre", [_vm._v(_vm._s(_vm.two_fa_secret))]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n                Enter the secret code in your 2FA Authenticator or scan the following QR code"
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("qrcode", {
                        attrs: {
                          value: _vm.g2fa_link_string.replace(
                            "SECRET_CODE",
                            _vm.two_fa_secret
                          ),
                          options: { width: 200 }
                        }
                      }),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "c-form" }, [
                        _c(
                          "div",
                          { staticClass: "row form-group c-form__group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "col-12 c-form__label",
                                attrs: { for: "verification_code" }
                              },
                              [_vm._v("Enter verification code:")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("b-form-input", {
                                  staticClass: "c-form__field",
                                  attrs: { id: "verification_code" },
                                  model: {
                                    value: _vm.verification_code,
                                    callback: function($$v) {
                                      _vm.verification_code =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "verification_code"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row form-group c-form__group" },
                          [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "c-btn c-btn--success",
                                  on: { click: _vm.activate_2fa }
                                },
                                [
                                  _vm._v(
                                    "\n                                Activate 2FA\n                            "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  : [
                      _c("p", { staticClass: "alert alert-success" }, [
                        _vm._v("Google 2FA Activated!")
                      ]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "c-btn c-btn-default",
                          attrs: { to: { name: "login.main" } }
                        },
                        [
                          _vm._v(
                            "\n                    Sign In\n                "
                          )
                        ]
                      )
                    ]
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("twofa-setup-ccs-modal")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-box__header mb-5" }, [
      _c("div", { staticClass: "c-box__title text-center text-uppercase" }, [
        _vm._v("\n            2FA Setup\n        ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }